module.exports = __webpack_public_path__ + "static/christianwork1-e625fb345fddb060adaf2afd7ee691b2.jpg";